import { render, staticRenderFns } from "./PaidGalleries.vue?vue&type=template&id=4a0f1bb9"
import script from "./PaidGalleries.vue?vue&type=script&lang=js"
export * from "./PaidGalleries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports